module.exports = __webpack_public_path__ + "static/img/banner_bg.2332946b.png";